import React from "react";
import { StudentsUIProvider } from "./StudentsUIContext";
import { StudentsCard } from "./StudentsCard";

export function StudentsPage({
  setReceipentIds
}) {
  return (
    <StudentsUIProvider>
      <StudentsCard
        setReceipentIds={setReceipentIds}
      />
    </StudentsUIProvider>
 );
}